import { render, staticRenderFns } from "./BotoneraEdicion.vue?vue&type=template&id=36b75484"
import script from "./BotoneraEdicion.vue?vue&type=script&lang=js"
export * from "./BotoneraEdicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports